import React from 'react';
import { TextField } from '../../items/TextField';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import request from '../../../services/Request';
import { Modal, Button } from '../../../components/BootstrapToMUI';
import '../../items/formFields.css';
import Swal from 'sweetalert2';

import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';

export default function SmtpConfiguration({ show, onHide }) {
  const [smtpUser, setSmtpUser] = useState('');
  const [smtpPassword, setSmtpPassword] = useState('');
  const [smtpPort, setSmtpPort] = useState('');
  const [smtpHost, setSmtpHost] = useState('');
  const [smtpUserAuto, setSmtpUserAuto] = useState('');
  const [smtpPasswordAuto, setSmtpPasswordAuto] = useState('');
  const [smtpPortAuto, setSmtpPortAuto] = useState('');
  const [smtpHostAuto, setSmtpHostAuto] = useState('');
  const [smtpUserAlps, setSmtpUserAlps] = useState('');
  const [smtpPasswordAlps, setSmtpPasswordAlps] = useState('');
  const [smtpPortAlps, setSmtpPortAlps] = useState('');
  const [smtpHostAlps, setSmtpHostAlps] = useState('');

  const history = useHistory();

  const dashboard = async () => {
    history.push('/dashboard');
  };

  useEffect(() => {
    request({
      method: 'get',
      url: `/email/get-server-config-data`,
    }).then((emailConfig) => {
      setSmtpHost(emailConfig.data.host);
      setSmtpPassword(emailConfig.data.password);
      setSmtpPort(emailConfig.data.port);
      setSmtpUser(emailConfig.data.user);
      setSmtpHostAuto(emailConfig.data.host_auto);
      setSmtpPasswordAuto(emailConfig.data.password_auto);
      setSmtpPortAuto(emailConfig.data.port_auto);
      setSmtpUserAuto(emailConfig.data.user_auto);
      setSmtpHostAlps(emailConfig.data.host_alps);
      setSmtpPasswordAlps(emailConfig.data.password_alps);
      setSmtpPortAlps(emailConfig.data.port_alps);
      setSmtpUserAlps(emailConfig.data.user_alps);
    });
  }, []);

  return (
    <Modal
      show={show}
      onHide={() => {
        onHide();
        dashboard();
      }}
      centered
      scrollable
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Configure SMTP Server</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Formik
          enableReinitialize
          initialValues={{
            user: smtpUser,
            password: smtpPassword,
            port: smtpPort,
            host: smtpHost,
            user_auto: smtpUserAuto,
            password_auto: smtpPasswordAuto,
            port_auto: smtpPortAuto,
            host_auto: smtpHostAuto,
            user_alps: smtpUserAlps,
            password_alps: smtpPasswordAlps,
            port_alps: smtpPortAlps,
            host_alps: smtpHostAlps,
          }}
          validationSchema={Yup.object({
            host: Yup.string().required(),
            password: Yup.string().required(),
            port: Yup.number().required(),
            user: Yup.string().required(),
          })}
          onSubmit={(values, { setSubmitting }) => {
            let data = new FormData();
            setSubmitting(true);
            if (
              smtpHost === values.host &&
              smtpPassword === values.password &&
              smtpPort === values.port &&
              smtpUser === values.user &&
              smtpHostAuto === values.host_auto &&
              smtpPasswordAuto === values.password_auto &&
              smtpPortAuto === values.port_auto &&
              smtpUserAuto === values.user_auto &&
              smtpHostAlps === values.host_alps &&
              smtpPasswordAlps === values.password_alps &&
              smtpPortAlps === values.port_alps &&
              smtpUserAlps === values.user_alps
            ) {
              Swal.fire({
                text: `No changes have been applied!`,
                icon: 'error',
              });
            } else {
              if (smtpHost !== values.host) data.append('host', values.host);
              if (smtpPassword !== values.password) data.append('password', values.password);
              if (smtpPort !== values.port) data.append('port', values.port);
              if (smtpUser !== values.user) data.append('user', values.user);
              if (smtpHostAuto !== values.host_auto) data.append('host_auto', values.host_auto);
              if (smtpPasswordAuto !== values.password_auto)
                data.append('password_auto', values.password_auto);
              if (smtpPortAuto !== values.port_auto) data.append('port_auto', values.port_auto);
              if (smtpUserAuto !== values.user_auto) data.append('user_auto', values.user_auto);
              if (smtpHostAlps !== values.host_alps) data.append('host_alps', values.host_alps);
              if (smtpPasswordAlps !== values.password_alps)
                data.append('password_alps', values.password_alps);
              if (smtpPortAlps !== values.port_alps) data.append('port_alps', values.port_alps);
              if (smtpUserAlps !== values.user_alps) data.append('user_alps', values.user_alps);

              request({
                method: 'post',
                url: `/email/update-server-config-data`,
                data: data,
              }).then((res) => {
                setSubmitting(false);
                Swal.fire({
                  text: 'Server configuration has been successfully updated!',
                  icon: 'success',
                });
              });
            }
          }}
        >
          {(formik) => (
            <div>
              <Form>
                <TextField label="User" name="user" type="email" as="input" />
                <TextField
                  label="Password"
                  name="password"
                  type="password"
                  placeholder="Type a new password"
                  as="input"
                />
                <TextField label="Port" name="port" type="number" as="input" />
                <TextField label="Host" name="host" type="text" as="input" />
                <hr style={{ background: 'black' }} />
                <hr style={{ background: 'black' }} />
                <TextField label="User_Auto" name="user_auto" type="email" as="input" />
                <TextField
                  label="Password_Auto"
                  name="password_auto"
                  type="password"
                  placeholder="Type a new password"
                  as="input"
                />
                <TextField label="Port_Auto" name="port_auto" type="number" as="input" />
                <TextField label="Host_Auto" name="host_auto" type="text" as="input" />
                <hr style={{ background: 'black' }} />
                <hr style={{ background: 'black' }} />
                <TextField label="User_Alps" name="user_alps" type="email" as="input" />
                <TextField
                  label="Password_Alps"
                  name="password_alps"
                  type="password"
                  placeholder="Type a new password"
                  as="input"
                />
                <TextField label="Port_Alps" name="port_alps" type="number" as="input" />
                <TextField label="Host_Alps" name="host_alps" type="text" as="input" />
                <div className="submit_btn">
                  <Button type="submit" className="btn-success">
                    {formik.isSubmitting ? 'Submitting...' : 'Submit'}
                  </Button>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
